export enum PaymentProvider {
    Braintree, FastSpring,
}
